// src/index.js
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./index.css";
import App from "./App";
import Homepage from "./homepage";
import Layout from "./Layout";
import reportWebVitals from "./reportWebVitals";
import Updates from "./Updates.jsx";
import Reports from "./Reports";
import Profile from "./Profile";
import Project from "./Project.jsx";

// ---- Simple auth guard ----
function RequireAuth({ children }) {
  const authed = Boolean(localStorage.getItem("token")); // token only
  return authed ? children : <Navigate to="/" replace />;
}

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Public route (login) */}
        <Route path="/" element={<App />} />

        {/* Everything under Layout is protected */}
        <Route
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route path="/Homepage" element={<Homepage />} />
          <Route path="/homepage" element={<Homepage />} />
          <Route path="/Updates" element={<Updates />} />
          <Route path="/Profile" element={<Profile />} />
          <Route path="/Project" element={<Project />} />
          <Route path="/Settings" element={<div>Settings page</div>} />
          <Route path="/Reports" element={<Reports />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
